import * as activiti2 from "./activiti";
import * as bpmApprovaTask from "./bpmApprovaTask";
import * as bpmProc from "./bpmProc";
import * as business from "./business";
import * as financeApprovalFacadeImpl from "./financeApprovalFacadeImpl";
import * as simpleTodoLinks from "./simpleTodoLinks";

export const activiti = {
  activiti: activiti2,
  bpmApprovaTask,
  bpmProc,
  business,
  financeApprovalFacadeImpl,
  simpleTodoLinks,
};
